<template>
  <div class="gl-bg wh pr Home">
    <div class="wh bgBox">
      <div class="phoneBox">
        <div id="container" class="conter wh">
          <video
            id="videoID"
            ref="video"
            class="videoK wh pa"
            :muted="videoMutedStatus"
            loop
            :autoplay="false"
            :src="curVideo"
          ></video>
          <div
            class="wh pa tuceng"
            v-if="!pauseStatus && !ydStatus"
            @mousedown="mousemoveClick"
            @touchmove="mousemoveClick"
          ></div>
          <div
            v-if="!pauseStatus"
            class="videoPayBtn pa cursor"
            :class="!pauseStatus ? 'pauseBox' : 'palyBox'"
            @click="palyClick"
            @touchstart="palyClick"
          ></div>
        </div>
      </div>
      <!--语音讲解-->
      <div class="voiceBtnBox pa">
        <div
          class="mutedClass cursor"
          :class="videoMutedStatus ? 'mutedNoPlay' : 'mutedPlay'"
          @click="mutedClick"
        ></div>
        <div class="voiceText">{{ $t("p1.Explanation") }}</div>
      </div>
      <!--字幕解析-->
      <div
        class="pa subtitleTextBox"
        v-if="
          item.startTime >= SubStartTime &&
            item.endTime <= SubEndTime &&
            index > 10
        "
        v-for="(item, index) in subTitleData"
        :key="index"
      >
        {{ item.text }}
      </div>
      <!--控制面板-->
      <div class="controlBox pa">
        <div :class="!controlStatus ? 'hideClass' : ''" class="control pr">
          <div
            class="navigation hoveClass pa"
            @click="navigationStatus = !navigationStatus"
          ></div>
          <!--<div class="mapIocn hoveClass pa" @click="mapStatusClick"></div>-->
          <!--<div class="Control_list pa">-->
          <!--<div class="liClass li_1 hoveClass" @click="rotateLeft"></div>-->
          <!--<div class="liClass li_2 hoveClass" @click="rotateRight"></div>-->
          <!--<div class="liClass li_3 hoveClass" @click="rotateUp"></div>-->
          <!--<div class="liClass li_4 hoveClass" @click="rotateDown"></div>-->
          <!--<div class="liClass li_5 hoveClass" @click="zoomOut"></div>-->
          <!--<div class="liClass li_6 hoveClass" @click="zoomIn"></div>-->
          <!--</div>-->
          <div
            @click="fullScreenClick"
            class="liClass hoveClass"
            :class="!fullScreenStatus ? 'fullScreen' : 'NofullScreen'"
          ></div>
          <div class="liClass down  hoveClass" @click="downClick"></div>
          <div class="controlsBox pa">
            <div
              class="videoPayBtn pa cursor"
              :class="!pauseStatus ? 'pauseBox' : 'palyBox'"
              @click="palyClick"
            ></div>
            <div class="progressBox pa cursor clear" id="progressBoxWi">
              <div class="pa timeClass">
                {{ currentTimeTotal }}/{{ totalTimeTotal }}
              </div>
              <div class="progress pa" id="progress"></div>
            </div>
          </div>
        </div>
        <!--向上箭头-->
        <div
          class="topBtn cursor pa"
          @click="topClick"
          :class="controlStatus ? 'showClass' : ''"
        ></div>
      </div>
      <!--导航面板-->
      <div v-show="navigationStatus" class="navBox a-fadein pa">
        <swiper :options="swiperOption" class="swiper-container pr">
          <swiper-slide
            class="swiper-slide cursor"
            v-for="(item, index) in carouselArr"
            :key="index"
          >
            <div
              class="wh detailBox pr"
              :class="swiperStatus == index ? 'sele' : ''"
              @click="swiperClick(item.indexId, item.videoDate)"
            >
              <img class="pa wh" :src="item.imgSrc" />
              <div class="text_ pa">{{ item.text }}</div>
            </div>
          </swiper-slide>
        </swiper>
        <div class="swiper-button-prev pa" slot="button-prev"></div>
        <div class="swiper-button-next pa" slot="button-next"></div>
      </div>
      <!--地图面板-->
      <div class="mapBox a-fadein">
        <div class="mapDian pa" v-show="mapStatus">
          <div class="coordinate pa" @click="mapClick(485)"></div>
          <div class="coordinate pa" @click="mapClick(238)"></div>
          <div class="coordinate pa" @click="mapClick(561)"></div>
          <div class="coordinate pa" @click="mapClick(208)"></div>
          <div class="coordinate pa" @click="mapClick(79)"></div>
          <div class="coordinate pa" @click="mapClick(307.5)"></div>
          <div class="coordinate pa" @click="mapClick(362)"></div>
          <!--<div class="coordinate pa" @click="mapClick()"></div>-->
        </div>
        <!--描述-->
        <div
          class="writtenBox pa"
          v-if="
            swiperStatus == index &&
              detailStatusFun &&
              timeDate >= item.start &&
              timeDate <= item.stop
          "
          v-for="(item, index) in carouselArr"
          :class="!jtImgStatus ? 'rightDefull' : ''"
        >
          <div class="w-text pa">
            <div class="textBg pa" v-html="item.detailText"></div>
          </div>
          <div class="rightBg pa cursor" @click="jtImgStatus = !jtImgStatus">
            <div class="jtImg pa" :class="jtImgStatus ? '' : 'route'"></div>
          </div>
        </div>
      </div>
      <!--iframe-->
      <div class="iframeBox pa wh" v-if="iframeStatus">
        <iframe
          allowtransparency="true"
          style="background: rgba(0,0,0,0)"
          id="krpano_iframe_iframesrc"
          num="null"
          width="100%"
          height="100%"
          :src="iframeUrl"
          frameborder="0"
          allow-same-origin=""
          allowfullscreen=""
        >
        </iframe>
        <div class="closeBtn pa cursor" @click="iframeStatus = false"></div>
        <div
          v-if="curAudio"
          class="autoClass pa cursor"
          @click="audioClick"
          :class="!audioPlay ? 'closeAudio' : ''"
        >
          <audio :autoplay="audioPlay" id="bg-music" :src="curAudio"></audio>
        </div>
      </div>
      <!--中英文切换-->
      <!--<div class="classLang pa cursor" :class="this.$i18n.locale == 'en-US'? 'classLangCN':'classLangEN'" @click="langClick"></div>-->
    </div>
  </div>
</template>
<script>
var TCPVideoTimer;
import { VideoProControl } from "../webgl/control/VideoProControl";
import Swiper from "swiper";
import { WebGLScene } from "../webgl/WebGLScene";
import { PANO_CONFIG } from "../webgl/panorama/PanoConfig";
import { TimeLineMana } from "../webgl/TimeLineMana";
import { globalEvent } from "../webgl/panorama/PanoConfig";
import { PanoEvent } from "../webgl/events/PanoEvents";
export default {
  name: "Home",
  data() {
    return {
      audioPlay: true,
      iframeUrl: null,
      iframeStatus: false,
      timeDate: 0,
      videoDom: null,
      timer: null,
      //当前播放时间
      currentTimeTotal: "00:00",
      //总时长
      totalTimeTotal: "00:00",
      // webgl scene
      timerId: null,
      scene: null,
      subIndex: 0,
      SubStartTime: null,
      SubEndTime: null,
      detailStatusFun: true,
      pauseStatus: false,
      ydStatus: false,
      swiperStatus: 0,
      playStatus: true,
      navigationStatus: false, // 导航状态
      mapStatus: false, // 地图状态
      controlStatus: true, // 控制面板箭头状态
      jtImgStatus: true, // 文字箭头状态
      fullScreenStatus: false, // 全屏状态
      videoMutedStatus: true, // 语音讲解状态
      curVideo: "./static/video/1.mp4",
      curAudio: "./static/mp3/mp3_1.mp3",
      subTitleData: [],
      carouselArr: [],
      //      carouselArr: [
      //        {
      //          indexId: 0,
      //          videoDate: 39,
      //          imgSrc: './static/images/nav/thumb.jpg',
      //          text: '外景',
      //          start: 39,
      //          stop: 79,
      //          detailStatus: true,
      //          detailText: '<div class="text">您好，欢迎来到杭州华为全球培训中心。<br>\n' +
      //          '    华为全球培训中心位于浙江杭州钱塘江畔，立足ICT行业人才生态建设，为全球170多个国家和地区的客户及高端人才提供ICT人才发展咨询、ICT技术培训、行业人才培养和数字化领导力培训服务。<br>\n' +
      //          '    全球培训中心总占地面积13.2万㎡，约等于20个足球场大小，拥有7大产品线实验室（核心网/无线/传输/数通/接入/能源/IT），实验室面积32630 ㎡，可同时容纳约2000人/天的培训接待，开设课程覆盖华为5G、大数据、云、物联网、AI等最新前沿技术领域。\n' +
      //          '    全球培训中心整体建筑结构借鉴了莫斯科红场古姆百货的钢型拱顶建筑风格，将古典建筑拱廊放在建筑中心，四周以内院围合，外立面呈现简约的当代风格，建筑风格典雅、大气而时尚。<br>\n' +
      //          '园区共有四幢大楼：T1为教职楼，T2为实验楼，T3为教学楼，T4为餐厅。<br>\n' +
      //          '您现在所在位置是T3教学楼，建筑面积约6.8万 ㎡，一共三层，提供143间培训教室，可容纳2200多人同时参加培训。\n' +
      //          '</div>'
      //        }, {
      //          indexId: 1,
      //          videoDate: 35,
      //          imgSrc: './static/images/nav/thumb2.jpg',
      //          text: '中心喷泉',
      //          start: 35,
      //          stop: 37,
      //          detailStatus: true,
      //          detailText: '<div class="text">您好，欢迎来到杭州华为全球培训中心。<br>\n' +
      //          '    华为全球培训中心位于浙江杭州钱塘江畔，立足ICT行业人才生态建设，为全球170多个国家和地区的客户及高端人才提供ICT人才发展咨询、ICT技术培训、行业人才培养和数字化领导力培训服务。<br>\n' +
      //          '    全球培训中心总占地面积13.2万㎡，约等于20个足球场大小，拥有7大产品线实验室（核心网/无线/传输/数通/接入/能源/IT），实验室面积32630 ㎡，可同时容纳约2000人/天的培训接待，开设课程覆盖华为5G、大数据、云、物联网、AI等最新前沿技术领域。\n' +
      //          '    全球培训中心整体建筑结构借鉴了莫斯科红场古姆百货的钢型拱顶建筑风格，将古典建筑拱廊放在建筑中心，四周以内院围合，外立面呈现简约的当代风格，建筑风格典雅、大气而时尚。<br>\n' +
      //          '园区共有四幢大楼：T1为教职楼，T2为实验楼，T3为教学楼，T4为餐厅。<br>\n' +
      //          '您现在所在位置是T3教学楼，建筑面积约6.8万 ㎡，一共三层，提供143间培训教室，可容纳2200多人同时参加培训。\n' +
      //          '</div>'
      //        }, {
      //          indexId: 2,
      //          videoDate: 79,
      //          imgSrc: './static/images/nav/thumb3.jpg',
      //          text: '华为ICT人才生态体验中心',
      //          start: 79,
      //          stop: 89,
      //          detailStatus: false,
      //          detailText: ''
      //        }, {
      //          indexId: 3,
      //          videoDate: 90,
      //          imgSrc: './static/images/nav/thumb4.jpg',
      //          text: '人才标准制定',
      //          start: 90,
      //          stop: 100,
      //          detailStatus: false,
      //          detailText: ''
      //        }, {
      //          indexId: 4,
      //          videoDate: 202,
      //          imgSrc: './static/images/nav/thumb5.jpg',
      //          text: '留言',
      //          start: 202,
      //          stop: 208,
      //          detailStatus: false,
      //          detailText: ''
      //        }, {
      //          indexId: 5,
      //          videoDate: 362,
      //          imgSrc: './static/images/nav/thumb6.jpg',
      //          text: '行业人才培训实训中心',
      //          start: 362,
      //          stop: 382,
      //          detailStatus: true,
      //          detailText: '<div class="text">行业人才培养实训中心支持公共安全、金融、智慧城市、智慧校园等基于真实服务场景的培训解决方案。<br>\n' +
      //          '    ICT技术与服务的集成越来越紧密，我们不能只关注某个设备或者解决方案，而应该了解完整的服务流程、以及如何保证业务的顺利运行，这才是技术工程师们应该具有的核心能力。<br>\n' +
      //          '    实际工作中也许您不能随意配置现网参数进行测试和实验，但是实训中心提供了一个真实的网络供大家学习和验证，让学习的过程更加贴近实际工作场景。<br>\n' +
      //          '    教室前面的大屏可以配合模拟指挥中心的复杂运作场景，面对突发紧急状况，训练团队配合以及解决问题的能力，在实践中检验学员们的 对知识的理解和应用能力。<br>\n' +
      //          '    教室后面还有两个功能性的会议室，分别是融合会商室和技术运维中心。<br>\n' +
      //          '    我们希望给客户带来更贴近日常工作和突发问题解决的实战型培训，让培训内容可以启发大家日常问题的解决以及提高每位学员自身的能力和团队协同作战实力。\n' +
      //          '    </div>'
      //        }, {
      //          indexId: 6,
      //          videoDate:208,
      //          imgSrc: './static/images/nav/thumb7.jpg',
      //          text: '报告厅',
      //          start: 208,
      //          stop: 238,
      //          detailStatus: true,
      //          detailText: '<div class="text">欢迎来到报告厅<br>\n' +
      //          '    这是一个配套有3米*6米的高清大屏幕、179个座位的报告厅。还设置了独立的影音系统室和更衣室。报告 厅使用视频矩阵，支持全球视频会议。<br>\n' +
      //          '    通常我们用它来做论坛、技术报告等，每个月我们都会选择一个技术领域作为主题，每周在大厅举行一次技术研讨会。<br>\n' +
      //          '    学员可以选择自己感兴趣的话题参加本次研讨会。<br>\n' +
      //          '    这里也是全球学员交流的平台，来自不同国家的学员交流思想，碰撞出智慧的火花。\n' +
      //          '    </div>'
      //        }, {
      //          indexId: 7,
      //          videoDate:307.5,
      //          imgSrc: './static/images/nav/thumb8.jpg',
      //          text: '实验室',
      //          start: 307,
      //          stop: 352,
      //          detailStatus: true,
      //          detailText: '<div class="text">华为投资逾2000万美元，打造包括数据通信、传输、云、存储、5G、eLTE等全产品线在内的全方位运营场景。<br>\n' +
      //          '    同样在现网环境中无法测试的内容和故障应急处理方案，都可以在实验室里完成。<br>\n' +
      //          '    实验室总面积超过11000平方米，培训内容中设置了丰富的动手实验环节，资源可以满足所有学员得到充分的练习。<br>\n' +
      //          '    即使是客户无法来到培训中心的远程培训，我们也试验提供 模拟平台“elab”，帮助学员进行远程实验室实践。\n' +
      //          '    </div>'
      //        }, {
      //          indexId: 8,
      //          videoDate: 238,
      //          imgSrc: './static/images/nav/thumb9.jpg',
      //          text: '多媒体教室',
      //          start: 238,
      //          stop: 307,
      //          detailStatus: true,
      //          detailText: '<div class="text">多媒体教室参考业界先进的设计理念并进行优化，320平方米阶梯教室，可容纳115人学习。<br>\n' +
      //          '    这里还配置超宽融合屏以及同声翻译室，主要用于大型客户开班、专家讲坛、团体接待及学习需求。\n' +
      //          '    </div>'
      //        }, {
      //          indexId: 9,
      //          videoDate:485,
      //          imgSrc: './static/images/nav/thumb10.jpg',
      //          text: '培训教室',
      //          start: 485,
      //          stop: 561,
      //          detailStatus: true,
      //          detailText: '<div class="text">您现在看到的是143间教室中的其中一间，教室配套可移动、且带触摸功能的电子白板，更加方便学员参与课堂互动。<br>\n' +
      //          '    上课绝不是老师单方面的知识输出，学员们的分享和交流也是非常重要的，我们创造自由轻松的课堂环境，确保每个学员对知识都获得充分的理解。\n' +
      //          '    </div>'
      //        },
      //        /*{
      //          imgSrc: './static/images/nav/thumb11.jpg',
      //          text: 'HCIE考试中心'
      //        },*/
      //        {
      //          indexId: 10,
      //          videoDate:561,
      //          imgSrc: './static/images/nav/thumb12.jpg',
      //          text: '图书馆',
      //          start: 561,
      //          stop: 580,
      //          detailStatus: false,
      //          detailText: ''
      //        }
      //      ],
      swiperOption: {
        pagination: ".swiper-pagination1",
        slidesPerView: 7,
        spaceBetween: 10,
        slidesPerGroup: 3,
        // 左右导航栏
        nextButton: ".swiper-button-next",
        prevButton: ".swiper-button-prev"
      }
    };
  },
  methods: {
    // iframe 音频播放暂停
    audioClick() {
      var audio = document.getElementById("bg-music");
      if (audio !== null) {
        if (audio.paused) {
          audio.play();
          this.audioPlay = true;
        } else {
          audio.pause();
          this.audioPlay = false;
        }
      }
    },
    // 中英文切换
    langClick() {
      if (this.$i18n.locale == "cn-ZH") {
        this.$i18n.locale = "en-US";
      } else {
        this.$i18n.locale = "cn-ZH";
      }
    },
    //    监控视频播放进度
    videoProgress: function() {
      var that = this;
      clearTimeout(TCPVideoTimer);
      if (that.playStatus) {
        TCPVideoTimer = setTimeout(function() {
          var video = that.$refs.video;
          that.coverTest(video.currentTime);
          that.videoProgress();
        }, 100);
      }
    },
    coverTest(time) {
      var that = this;
      //      console.log(time)
      that.timeDate = time;
      that.carouselArr.map(function(val, index) {
        if (time >= val.start && time <= val.stop) {
          that.swiperStatus = val.indexId;
          that.detailStatusFun = val.detailStatus;
        }
      });
      that.subTitleData.map(function(val, index) {
        if (time >= val.startTime && time <= val.endTime) {
          that.subIndex = index;
          that.SubStartTime = val.startTime;
          that.SubEndTime = val.endTime;
          console.log(that.SubStartTime);
        }
      });
    },

    // 视频时长
    setProgress() {
      var that = this;
      var videoDom = document.getElementById("videoID");
      this.timer = setInterval(function() {
        var currentTimeTotal = videoDom.currentTime;
        var totalTimeTotal = videoDom.duration;
        that.currentTimeTotal = that.getFormatVideoTime(currentTimeTotal);
        that.totalTimeTotal = that.getFormatVideoTime(totalTimeTotal);
      }, 50);
    },
    //时间格式化处理
    getFormatVideoTime(time) {
      let curtime = time;
      let m = parseInt((curtime % 3600) / 60);
      let s = parseInt(curtime % 60);
      m = m < 10 ? "0" + m : m;
      s = s < 10 ? "0" + s : s;
      return m + ":" + s;
    },

    px2Fun($value) {
      var cuurWidth = document.body.clientWidth;
      var scale = cuurWidth / 1920;
      return $value * scale;
    },
    mousemoveClick() {
      this.ydStatus = true;
    },
    // 播放
    palyClick() {
      var that = this;
      this.ydStatus = true;
      this.videoMutedStatus = false;
      var videoID = document.getElementById("videoID");
      if (videoID.paused) {
        videoID.play();
        that.pauseStatus = true;
      } else {
        videoID.pause();
        that.pauseStatus = false;
      }
    },
    // 导航swiper点击
    swiperClick(index, date_) {
      this.swiperStatus = index;
      this.pauseStatus = true;
      this.scene.renderMain.switchAniStart().then(() => {
        var videoID = document.getElementById("videoID");
        videoID.currentTime = date_;
        videoID.play();
      });
    },
    //    地图面板点击切换视频场景
    mapClick(timeD) {
      var that = this;
      that.mapStatus = false;
      this.scene.renderMain.switchAniStart().then(() => {
        var videoID = document.getElementById("videoID");
        videoID.currentTime = timeD;
        videoID.play();
      });
      this.carouselArr.map(function(val, index) {
        if (val.videoDate == timeD) {
          that.swiperStatus = index;
          console.log(index);
        }
      });
    },
    // 控制面板 图标 地图点击
    mapStatusClick() {
      this.mapStatus = !this.mapStatus;
      this.carouselArr[0].detailText =
        '<div class="text">在多元风格的华美建筑内部，华为全球培训中心为充分满足不同国度、不同宗教信仰的学员学习、生活的需要，配置了中西自助餐厅、咖啡馆、便利店、图书馆、祈祷室、医务室和健身房等功能区。</div>';
    },
    // 语音讲解
    mutedClick() {
      this.videoMutedStatus = !this.videoMutedStatus;
      if (this.videoMutedStatus) {
        this.audioPlay = false;
      } else {
        this.audioPlay = true;
      }
    },
    // 全屏非全屏
    fullScreenClick() {
      this.fullScreenStatus = !this.fullScreenStatus;
      if (this.fullScreenStatus) {
        var element = document.documentElement;
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.msRequestFullscreen) {
          element.msRequestFullscreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.webkitRequestFullscreen) {
          element.webkitRequestFullscreen();
        }
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        }
      }
    },
    // 点击隐藏或显示控制面板
    downClick() {
      this.controlStatus = false;
      this.navigationStatus = false;
      this.mapStatus = false;
    },
    topClick() {
      this.controlStatus = true;
    },
    // 左旋
    rotateLeft() {
      this.scene.renderMain.control.rotateLeft(-0.3);
    },
    // 右旋
    rotateRight() {
      this.scene.renderMain.control.rotateLeft(0.3);
    },
    // 向上
    rotateUp() {
      this.scene.renderMain.control.rotateUp(0.3);
    },
    // 向下
    rotateDown() {
      this.scene.renderMain.control.rotateUp(-0.3);
    },
    // 放大
    zoomOut() {
      this.scene.renderMain.zoomOut(0.9);
    },
    // 缩小
    zoomIn() {
      this.scene.renderMain.zoomIn(0.9);
    },
    // 初始化场景
    init: function() {
      var that = this;

      // 设置视频
      PANO_CONFIG.VIDEO_DOM = this.videoDom;
      let container = document.getElementById("container");
      // 设置当前语言
      PANO_CONFIG.lang = this.$i18n.locale;
      that.scene = new WebGLScene(container, this.$i18n.locale);

      // 箭头标记选中
      globalEvent.addEventListener(PanoEvent.MARKER_SELECT, event => {
        console.log("event:", event.data);
        if (that.SubStartTime > 89 && that.SubStartTime < 200) {
          // iframe 状态
          this.iframeStatus = event.data.defaultShow;
          this.iframeUrl = event.data.iframeUrl;
          this.curAudio = event.data.mp3Url;
        }
      });

      //      let markerShow = new TimeLineMana(this.videoDom,this.scene.mainScene.panoSwitch.spriteMana.locations);
    },

    loadData(url, val) {
      var that = this;
      let xhr = new XMLHttpRequest();
      xhr.open("get", url);
      xhr.onreadystatechange = event => {
        // 数据请求完成
        if (xhr.readyState === 4 && xhr.status === 200) {
          try {
            let data = JSON.parse(xhr.responseText);
            console.log(data);
            if (val == 1) {
              that.carouselArr = data.carouselArr;
            } else {
              this.subTitleData = data.list;
            }
          } catch (err) {
            console.warn("场景数据加载失败");
            return;
          }
        }
      };
      xhr.send();
    }
  },
  watch: {
    iframeStatus(e) {
      var videoID = document.getElementById("videoID");
      console.log(e);
      if (e) {
        videoID.pause();
        this.pauseStatus = false;
      } else {
        videoID.play();
        this.pauseStatus = true;
      }
    }
  },
  beforeCreate() {},
  created() {},
  mounted() {
    //    监控视频播放进度
    if (this.$refs.video.play) {
      this.videoProgress();
    }

    /* 视频播放进度控制*/
    let videoDom = document.getElementById("videoID");
    this.videoDom = videoDom;
    let proDom = document.getElementById("progressBoxWi");
    this.videoProControl = new VideoProControl(videoDom, proDom);
    this.loadData("./static/json/carouselArr.json", 1);
    this.loadData("./static/json/output.json", 2);
    this.init();

    // 禁止鼠标左键拖动
    var ctrl = document.getElementsByClassName("navBox")[0];
    function stopEventHandler(event) {
      event.stopPropagation();
    }
    ctrl.addEventListener("mousedown", stopEventHandler);

    this.setProgress();
  },
  destroyed() {}
};
</script>
<style scoped lang="scss">
@import "./../assets/styles/common/functions";
.bgBox {
  width: 100%;
  height: 100%;
  .phoneBox {
    margin: 0 auto;
    height: 100%;
    .tuceng {
      z-index: 10000;
      background-image: url("./../assets/images/home/ydBg.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .conter {
      width: 100%;
      height: 100%;
    }
    .videoK {
      position: absolute;
      opacity: 0;
      width: 100%;
      height: 100%;
      left: px2(0);
      top: px2(0);
    }
    .videoPayBtn {
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: px2(105);
      height: px2(105);
      background-size: 100% 100%;
      background-repeat: no-repeat;
      &.palyBox {
        background-image: url("./../assets/images/home/icon_play.png");
      }
      &.pauseBox {
        background-image: url("./../assets/images/home/icon_play.png");
      }
    }
  }
  /*<!--语音讲解 s-->*/
  .voiceBtnBox {
    z-index: 30;
    left: px2(90);
    bottom: px2(20);
    text-align: center;
    font-size: px2(22);
    color: #fff;
    .mutedClass {
      width: px2(114);
      height: px2(115);
      color: #fff;
      @include keyani(30, 1);
    }
    .mutedNoPlay {
      background: url("../assets/images/home/musicstopxuliezhen.png");
      background-size: 100%;
    }
    .mutedPlay {
      background: url("../assets/images/home/musicopenxuliezhen.png");
      background-size: 100%;
    }
  }
  /*<!--语音讲解 e-->*/

  /*字幕解析 s*/
  .subtitleTextBox {
    left: 50%;
    transform: translateX(-50%);
    bottom: px2(200);
    text-align: center;
    font-size: px2(20);
    color: #fff;
    border-radius: px2(20);
    background-color: rgba(0, 0, 0, 0.2);
    padding: px2(5) px2(30);
  }
  /*字幕解析 e*/

  /*<!--控制面板 s-->*/
  .controlBox {
    z-index: 30;
    width: px2(814);
    height: px2(80);
    left: 0;
    right: 0;
    margin: 0 auto;
    bottom: px2(20);
    /*border: 1px solid red;*/
    .control {
      width: px2(790);
      height: px2(80);
      bottom: 0;
      margin: 0 auto;
      border-bottom: px2(1) solid #fff;
      padding-top: px2(5);
      transition: all 0.5s;
      .liClass {
        display: inline-block;
        margin-right: px2(10);
      }
      .down {
        margin-right: px2(0);
      }
      .hoveClass {
        cursor: pointer;
        &:hover {
          &:before {
            content: "";
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            width: px2(40);
            height: px2(40);
            background-color: #fff;
            border-radius: 50%;
            opacity: 0.3;
          }
        }
      }
      .navigation {
        width: px2(32);
        height: px2(23);
        background-image: url("./../assets/images/home/daohang.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
      .mapIocn {
        left: px2(50);
        width: px2(23);
        height: px2(23);
        background-image: url("./../assets/images/home/mapicon.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
      .liClass {
        width: px2(32);
        height: px2(32);
        position: relative;
      }
      .Control_list {
        width: px2(280);
        height: px2(32);
        left: 50%;
        top: 30%;
        transform: translate(-50%, -50%);
        display: flex;
        flex-wrap: nowrap;
        .li_1 {
          background: url("../assets/images/home/vtourskin_light.png") px2(0)
            px2(-96) / px2(66) px2(384);
        }
        .li_2 {
          background: url("../assets/images/home/vtourskin_light.png") px2(-32)
            px2(-96) / px2(66) px2(384);
        }
        .li_3 {
          background: url("../assets/images/home/vtourskin_light.png") px2(0)
            px2(-128) / px2(66) px2(384);
        }
        .li_4 {
          background: url("../assets/images/home/vtourskin_light.png") px2(-32)
            px2(-128) / px2(66) px2(384);
        }
        .li_5 {
          background: url("../assets/images/home/vtourskin_light.png") px2(0)
            px2(-160) / px2(66) px2(384);
        }
        .li_6 {
          background: url("../assets/images/home/vtourskin_light.png") px2(-32)
            px2(-160) / px2(66) px2(384);
        }
      }
      .fullScreen {
        position: absolute;
        right: px2(35);
        background: url("../assets/images/home/vtourskin_light.png") px2(0)
          px2(-288) / px2(66) px2(384);
      }
      .NofullScreen {
        position: absolute;
        right: px2(35);
        background: url("../assets/images/home/vtourskin_light.png") px2(-32)
          px2(-288) / px2(66) px2(384);
      }
      .down {
        position: absolute;
        right: px2(0);
        background: url("../assets/images/home/vtourskin_light.png") px2(0)
          px2(-224) / px2(66) px2(384);
      }
      .controlsBox {
        width: 100%;
        height: 50%;
        /*border: 1px solid red;*/
        bottom: 0;
        & div {
          display: inline-block;
          vertical-align: middle;
        }
        .videoPayBtn {
          bottom: px2(8);
          left: px2(5);
          width: px2(25);
          height: px2(25);
          background-size: 100% 100%;
          background-repeat: no-repeat;
          &.palyBox {
            background-image: url("./../assets/images/home/pause.png");
          }
          &.pauseBox {
            background-image: url("./../assets/images/home/play.png");
          }
        }
        .progressBox {
          height: px2(8);
          position: absolute;
          left: px2(40);
          bottom: px2(15);
          width: px2(740);
          background-color: rgba(255, 255, 255, 0.3);
          border-radius: px2(30);
          .progress {
            height: 100%;
            border-radius: px2(30);
            z-index: 100;
            left: 0;
            top: 0;
            width: 0;
            background-color: #fff;
          }
          .timeClass {
            right: 0;
            top: px2(8);
            font-size: px2(10);
            color: #fff;
            pointer-events: none;
          }
        }
      }
    }
    .topBtn {
      position: absolute;
      width: px2(32);
      height: px2(32);
      left: 50%;
      transform: translateX(-50%);
      bottom: px2(2);
      background: url("../assets/images/home/vtourskin_light.png") px2(-32)
        px2(-224) / px2(66) px2(384);
      opacity: 0.2;
      transition: all 0.5s;
      &:hover {
        opacity: 1;
      }
    }
    .hideClass {
      bottom: px2(-200);
    }
    .showClass {
      bottom: px2(-200);
    }
  }
  /*<!--控制面板 e-->*/
  /*导航 s*/
  .navBox {
    z-index: 30;
    width: px2(790);
    height: px2(80);
    left: 0;
    right: 0;
    margin: 0 auto;
    bottom: px2(100);
    background-image: url("./../assets/images/home/zongdaohang.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    padding: 0 px2(83);
    .swiper-container {
      width: 100%;
      height: 100%;
    }
    .swiper-slide {
      text-align: center;
      background: #fff;
      width: px2(80) !important;
      height: px2(55);
      top: 50%;
      transform: translateY(-50%);
      /* Center slide text vertically */
      display: -webkit-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      .detailBox {
        padding: 0 px2(2.5);
        overflow: hidden;
        text-align: center;
        img {
          width: 100%;
          height: 100%;
          left: 0;
          top: 0;
        }
        .text_ {
          width: 96%;
          font-size: px2(10);
          color: #fff;
          text-align: center;
          bottom: px2(10);
        }
      }
      .sele {
        border: px2(1) solid #fff;
      }
    }
  }
  /*导航 e*/
  /*地图面板和文字描述 s*/
  .mapBox {
    z-index: 29;
    left: 0;
    top: 0;
    .mapDian {
      left: 50%;
      transform: translateX(-50%);
      top: px2(250);
      width: px2(671);
      height: px2(453);
      background-image: url("./../assets/images/home/map.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      .coordinate {
        cursor: pointer;
        left: px2(52);
        bottom: px2(126);
        width: px2(34);
        height: px2(44);
        background: url("./../assets/images/home/vtourskin_mapspot.png") 0px 0px /
          px2(34) px2(44);
      }
      .coordinate:nth-child(2) {
        left: px2(83);
        bottom: px2(113);
      }
      .coordinate:nth-child(3) {
        left: px2(146);
        bottom: px2(91);
      }
      .coordinate:nth-child(4) {
        left: px2(110);
        bottom: px2(190);
      }
      .coordinate:nth-child(5) {
        left: px2(331);
        bottom: px2(237);
      }
      .coordinate:nth-child(6) {
        left: px2(581);
        bottom: px2(224);
      }
      .coordinate:nth-child(7) {
        left: px2(530);
        bottom: px2(139);
      }
      .coordinate:nth-child(8) {
        left: px2(599);
        bottom: px2(113);
      }
    }
    .writtenBox {
      top: px2(0);
      width: px2(306);
      height: 100%;
      background-image: url("./../assets/images/home/bg-danmu.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      z-index: 1;
      right: 0;
      transition: right 0.5s;
      .w-text {
        overflow: hidden;
        width: 92%;
        height: 90%;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        overflow: hidden;
        overflow-y: auto;
        font-size: px2(20);
        line-height: px2(30);
        font-weight: 300;
        color: #fff;
        opacity: 0.7;
        .textBg {
          width: 100%;
          max-height: 100%;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
        }
      }
      .rightBg {
        top: 50%;
        transform: translateY(-50%);
        left: px2(-22);
        width: px2(22);
        height: px2(113);
        background-image: url("./../assets/images/home/bg-suofang.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        .jtImg {
          top: 45%;
          left: 20%;
          width: px2(15);
          height: px2(17);
          transform-origin: center;
          background: url("./../assets/images/home/sanjiao.png") no-repeat
            center / 100%;
        }
        .route {
          transform: rotate(180deg);
        }
      }
    }
    .rightDefull {
      right: px2(-306);
    }
  }
  /*地图面板e*/

  .iframeBox {
    z-index: 10000;
    left: 0;
    top: 0;
    overflow: hidden;
    background-color: rgba(0, 0, 0, 0.3);
    .closeBtn {
      right: px2(60);
      top: px2(80);
      width: px2(35);
      height: px2(35);
      background-image: url("./../assets/images/home/close.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .autoClass {
      right: px2(60);
      top: px2(130);
      width: px2(35);
      height: px2(35);
      background-image: url("./../assets/images/home/music_open.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      &.closeAudio {
        background-image: url("./../assets/images/home/music_close.png");
      }
    }
  }

  /*中英文切换s*/
  .classLang {
    width: px2(100);
    height: px2(100);
    left: px2(250);
    bottom: px2(60);
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .classLangCN {
    background-image: url("./../assets/images/common/cn.png");
  }
  .classLangEN {
    background-image: url("./../assets/images/common/en.png");
  }
  /*中英文切换e*/
}
</style>



// WEBPACK FOOTER //
// src/components/P1.vue